import { Model } from '@danangelus/ngx-app-core'

/**
 * Represents a user group
 *
 * @author Connor Wheatley
 */
export class Group extends Model {

    dn: string | undefined
    groupId: string | undefined
    displayName: string | undefined
    whenCreated: string | undefined
    whenChanged: string | undefined
    description: string | undefined
    locked: boolean | undefined

    constructor(group?: any) {
        super(group)

        this.locked = group?.locked === 'TRUE' || group?.locked === true
    }
}
